import breadcrumbComp from "../../common/breadcrumb-comp";
import issueService from "./report-service.js";
import EncryptUtility from "../../utility/js/encrypt-utility";
import Utility from "../../../shared/utility.js";
import DisplayTextData from "../../common/display-text-data.vue";
import FilterComp from "../../common/filter-comp.vue";
import AddFavourite from "../../utility/js/addFav";
import router from "../../../router/router";
import PieChart from "../../common/pie-chart.vue";
import moment from "moment";
export default {
  data() {
    return {
      backSlash: true,
      customPage: true,
      refresh: true,
      panel: 0,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      searchBugs: "",
      isFormValid: false,
      showClosedSwitch: false,
      totalRecords: 0,
      allBugData: [],
      uniqueStatus: [],
      reportedBy: [],
      recorded: [],
      issueData: [],
      editIssueData: [],
      deleteIssueData: [],
      filterData: [],
      filterSeverity: "",
      filterStatus: "",
      mainPage: "",
      subPage: "",
      pageUrl: "",
      subPageUrl: "",
      showAdd: false,
      page: "",
      actionList: [],
      favouriteList: [],
      filterOriginalData: [],
      severityID: "",
      chartOptionsDonut: null,
      statusID: "",
      feedbackIssueData: [],
      feedbackServityData: [],
      issueLegendColor: {
        New: "#42A5F5",
        "In Business Review": "#7E57C2",
        "Business Analysis Closed": "#26A69A",
        "Assign to Technical Team": "#FF7043",
        "In Development": "#FFA726",
        "In Testing": "#66BB6A",
        "Fixed in UAT": "#8D6E63",
        "Dev Completed": "#26C6DA",
        "Assign To Business Team": "#EC407A",
        "Reviewed By Business": "#AB47BC",
        Resolved: "#388E3C",
        "Available on Go-live": "#FBC02D",
        Closed: "#455A64",
        Duplicate: "#BDBDBD",
        "Not-Issue": "#789262",
        "User-Deleted": "#D32F2F",
        Reopen: "#F06292",
        Pass: "#43A047",
      },
      servitylegendColor: {
        Low: "#42A5F5",
        High: "#7E57C2",
        Medium: "#26A69A",
        Showstopper: "#FF7043",
      },
      dateDropDownList: [
        { name: "Today", value: 1 },
        { name: "Current Week", value: 2 },
        { name: "Current Month", value: 3 },
        { name: "Last 15 Days", value: 4 },
        { name: "Last 30 Days", value: 5 },
        { name: "Custom Date Range", value: 6 },
      ],
      statusChartOption: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 16,
              padding: 12,
              generateLabels: (chart) => {
                const data = chart.data;
                if (!data.labels || !data.datasets.length) return [];
                return data.labels.map((label, i) => {
                  const value = data.datasets[0].data[i];
                  const backgroundColor = data.datasets[0].backgroundColor[i];
                  return {
                    text: `${label} (${value})`,
                    fillStyle: backgroundColor,
                    strokeStyle: backgroundColor,
                    index: i,
                  };
                });
              },
            },
          },
          title: {
            display: true,
            text: "Status",
            font: {
              size: 16,
              weight: "bold",
            },
          },
        },
        onClick: (event, elements, chart) => {
          if (elements && elements.length > 0) {
            const idx = elements[0].index;
            const label = chart.data.labels[idx];
            if (window.onStatusChartClick) window.onStatusChartClick(label);
            this.onClickChart("status",label);
          }
        },
      },
      severityChartOption: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 16,
              padding: 12,
              generateLabels: (chart) => {
                const data = chart.data;
                if (!data.labels || !data.datasets.length) return [];
                return data.labels.map((label, i) => {
                  const value = data.datasets[0].data[i];
                  const backgroundColor = data.datasets[0].backgroundColor[i];
                  return {
                    text: `${label} (${value})`,
                    fillStyle: backgroundColor,
                    strokeStyle: backgroundColor,
                    index: i,
                  };
                });
              },
            },
          },
          title: {
            display: true,
            text: "Severity",
            font: {
              size: 16,
              weight: "bold",
            },
          },
        },
        onClick: (event, elements, chart) => {
          if (elements && elements.length > 0) {
            const idx = elements[0].index;
            const label = chart.data.labels[idx];
            if (window.onSeverityChartClick) window.onSeverityChartClick(label);
             this.onClickChart("serverity",label);
          }
        },
      },
      dateValue: 4, // Default to Last 15 Days
      start_date: "",
      end_date: "",
      required: [(v) => !!v || "Field is required"],
      max150Rule: [
        (v) => (v || "").length <= 150 || "Max Length of 150 character",
        (v) => !!v || "Field is required",
      ],
      json_fields: {
        "Issue Id": "issue_id",
        "Ticket Number": "ticket_number",
        Title: "title",
        Description: { field: "description", callback: (v) => Utility.stripHtml(v) },
        Severity: "severity",
        Status: "status",
        "Issue Type": "issue_type",
        "Reported By": "recorded",
        "Reported Date": "cdate",
        "Updated By": "updated",
        "Updated Date": "udate",
        "Schedule Completion Date": "sch_completion_date",
        Comments: { field: "comments", callback: (v) => Utility.stripHtml(v) },
      },
      allBugHeaders: [
        {
          text: "Ticket Number",
          align: "start",
          value: "ticket_number",
          class: "primary customwhite--text",
        },
        { text: "Title", value: "title", class: "primary customwhite--text" },
        {
          text: "Severity",
          value: "severity",
          class: "primary customwhite--text",
        },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        {
          text: "Issue Type",
          value: "issue_type",
          class: "primary customwhite--text",
        },
        {
          text: "Reported By",
          value: "recorded",
          class: "primary customwhite--text",
        },
        {
          text: "Reported Date ",
          value: "cdate",
          class: "primary customwhite--text",
        },
        {
          text: "Updated By",
          value: "updated",
          class: "primary customwhite--text",
        },
        {
          text: "Updated Date",
          value: "udate",
          class: "primary customwhite--text",
        },
        {
          text: "Schedule Completion Date",
          value: "sch_completion_date",
          class: "primary customwhite--text",
        },
        {
          text: "Operation",
          value: "action",
          class: "primary customwhite--text",
        },
      ],
      sortBy: "issue_id",
    };
  },
  async mounted() {
    this.getIssueStatusList();
    EncryptUtility.localStorageDecrypt("panelId")?this.panel=  EncryptUtility.localStorageDecrypt("panelId")=="open"?0:null:"";
    router.afterEach((to) => {
      if (
        !to.path.includes("feedback-tracker") &&
        !to.path.includes("feedback-tracker-details")
      ) {
        EncryptUtility.localStorageRemoveItem("FTServerityName");
        EncryptUtility.localStorageRemoveItem("FTStatusName");
      }
    });
    if (
      EncryptUtility.localStorageDecrypt("FTServerityName") !== null &&
      EncryptUtility.localStorageDecrypt("FTServerityName") !== undefined
    ) {
      this.filterSeverity =
        EncryptUtility.localStorageDecrypt("FTServerityName");
    }
    if (
      EncryptUtility.localStorageDecrypt("FTStatusName") !== null &&
      EncryptUtility.localStorageDecrypt("FTStatusName") !== undefined
    ) {
      this.filterStatus = EncryptUtility.localStorageDecrypt("FTStatusName");
    }
    if (
      EncryptUtility.localStorageDecrypt("FTOriginalData") !== null &&
      EncryptUtility.localStorageDecrypt("FTOriginalData") !== undefined
    ) {
      this.filterOriginalData = JSON.parse(
        EncryptUtility.localStorageDecrypt("FTOriginalData")
      );
      this.filterData = this.distinctValues(this.filterOriginalData);
    }
    if (this.filterStatus !== "" || this.filterSeverity !== "") {
      this.mountedFilterCall();
    } else {
      this.getAllIssueDetails(3);
    }
    this.getChartData(3);
    EncryptUtility?.localStorageDecrypt("searchText") ? this.searchBugs = EncryptUtility?.localStorageDecrypt("searchText") : this.searchBugs = "";
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.page = data.page;
    this.subPage = data.subPage;
    this.subPageUrl = data.subPageUrl;
  },
  computed: {
    excelFileName() {
      return Utility.excelFileName("Feedback Tracker");
    },
    issueChartData() {
      return Array.isArray(this.feedbackIssueData)
        ? this.feedbackIssueData.map((item) => ({
            label: item.issue_status,
            value: item.count,
          }))
        : [];
    },
    severityChartData() {
      return Array.isArray(this.feedbackServityData)
        ? this.feedbackServityData.map((item) => ({
            label: item.issue_severity,
            value: item.count,
          }))
        : [];
    },
    pageHeight () {
      return document.body.scrollHeight
    },
    computedStartDateFormattedMomentjs() {
      return this.start_date
        ? moment(this.start_date).format("MM/DD/YYYY")
        : moment(new Date().getTime() - 15 * 86400000).format("MM/DD/YYYY");
    },
    computedEndDateFormattedMomentjs() {
      return this.end_date
        ? moment(this.end_date).format("MM/DD/YYYY")
        : moment(new Date()).format("MM/DD/YYYY");
    },
  },
  methods: {
    //Format comments from JSON array
    formatComments(commentsHistory) {
      if (!commentsHistory || commentsHistory === "[]") {
        return "";
      }
      let comments = commentsHistory;
      if (typeof commentsHistory === "string" && commentsHistory.trim().startsWith("[")) {
        comments = JSON.parse(commentsHistory);
      }
      if (!Array.isArray(comments) || comments.length === 0) {
        return "";
      }
      return comments
        .map(comment => {
          const text = comment["New Comment"] || comment.comment;
          return text ? `New Comment: ${text}` : null;
        })
        .filter(Boolean)
        .join("\n");
    },
    //Reset Function
    resetFunction() {
      this.searchBugs = "";
      this.totalRecords = 0;
      this.issueData = [];
      this.editIssueData = [];
      this.deleteIssueData = [];
      this.filterData = [];
      this.filterSeverity = "";
      this.filterStatus = "";
      this.filterOriginalData = [];
      this.severityID = "";
      this.statusID = "";
      this.getIssueStatusList();
      this.getAllIssueDetails(3);
    },
    //Get All Issue/Bug list
    async getAllIssueDetails(passedValue) {
      this.allBugData = [];
      this.totalRecords = 0;
      this.getFilterData();
      let pass = passedValue;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: parseInt(pass),
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      if (
        Array.isArray(issueTrackerData) &&
        issueTrackerData.length > 0
      ) {
        this.allBugData = issueTrackerData.map((obj) => {
          return {
            ...obj,
            cdate: Utility.displayDateFormat(obj.cdate),
            udate: Utility.displayDateFormat(obj.udate),
            sch_completion_date:
              obj.sch_completion_date !== undefined
                ? Utility.displayDateFormat(obj.sch_completion_date)
                : "",
            comments: this.formatComments(obj.comments_history),
          };
        });
        this.totalRecords = this.allBugData.length;
      }
    },

    clearSearchText(){
      EncryptUtility.localStorageEncrypt("searchText","");
      this.searchBugs = "";
    },
    //On Filter Change
    filterSelected(name, type) {
      if (type == "severity") {
        this.filterSeverity = name;
        if (this.filterSeverity !== null && this.filterSeverity !== undefined) {
          EncryptUtility.localStorageEncrypt(
            "FTServerityName",
            this.filterSeverity.toString()
          );
        }
        if (
          this.filterOriginalData !== null &&
          this.filterOriginalData !== undefined
        ) {
          EncryptUtility.localStorageEncrypt(
            "FTOriginalData",
            JSON.stringify(this.filterOriginalData)
          );
        }
      } else if (type == "status") {
        this.filterStatus = name;
        if (this.filterStatus !== null && this.filterStatus !== undefined) {
          EncryptUtility.localStorageEncrypt(
            "FTStatusName",
            this.filterStatus.toString()
          );
        }
        if (
          this.filterOriginalData !== null &&
          this.filterOriginalData !== undefined
        ) {
          EncryptUtility.localStorageEncrypt(
            "FTOriginalData",
            JSON.stringify(this.filterOriginalData)
          );
        }
      }
      if (this.filterSeverity !== "" && this.filterStatus == "") {
        let filterSeverity = this.filterOriginalData[0]?.severity;
        let orderTypeFilterArray = filterSeverity.filter(
          (element) => element.type == this.filterSeverity
        );
        this.severityID = orderTypeFilterArray[0]?.severity_id;
        this.filterSeverityData(this.severityID);
      }
      if (this.filterStatus !== "" && this.filterSeverity == "") {
        let filterStatus = this.filterOriginalData[0]?.status;
        let statusFilterArray = filterStatus.filter(
          (element) => element.issue_status == this.filterStatus
        );
        this.statusID = statusFilterArray[0]?.issue_status_id;
        this.filterStatusData(this.statusID);
      }
      if (this.filterStatus !== "" && this.filterSeverity !== "") {
        let filterSeverity = this.filterOriginalData[0]?.severity;
        let orderTypeFilterArray = filterSeverity.filter(
          (element) => element.type == this.filterSeverity
        );
        this.severityID = orderTypeFilterArray[0]?.severity_id;
        let filterStatus = this.filterOriginalData[0]?.status;
        let statusFilterArray = filterStatus.filter(
          (element) => element.issue_status == this.filterStatus
        );
        this.statusID = statusFilterArray[0]?.issue_status_id;
        this.filterSeverityStatusData(this.severityID, this.statusID);
      }
    },
    mountedFilterCall() {
      if (this.filterSeverity !== "" && this.filterStatus == "") {
        let filterSeverity = this.filterOriginalData[0]?.severity;
        let orderTypeFilterArray = filterSeverity.filter(
          (element) => element.type == this.filterSeverity
        );
        this.severityID = orderTypeFilterArray[0]?.severity_id;
        this.filterSeverityData(this.severityID);
      }
      if (this.filterStatus !== "" && this.filterSeverity == "") {
        let filterStatus = this.filterOriginalData[0]?.status;
        let statusFilterArray = filterStatus.filter(
          (element) => element.issue_status == this.filterStatus
        );
        this.statusID = statusFilterArray[0]?.issue_status_id;
        this.filterStatusData(this.statusID);
      }
      if (this.filterStatus !== "" && this.filterSeverity !== "") {
        let filterSeverity = this.filterOriginalData[0]?.severity;
        let orderTypeFilterArray = filterSeverity.filter(
          (element) => element.type == this.filterSeverity
        );
        this.severityID = orderTypeFilterArray[0]?.severity_id;
        let filterStatus = this.filterOriginalData[0]?.status;
        let statusFilterArray = filterStatus.filter(
          (element) => element.issue_status == this.filterStatus
        );
        this.statusID = statusFilterArray[0]?.issue_status_id;
        this.filterSeverityStatusData(this.severityID, this.statusID);
      }
    },
    async filterSeverityStatusData(severityId, issueStatusID) {
      this.allBugData = [];
      this.totalRecords = 0;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 3,
        issue_id: "0",
        title: "",
        description: "",
        comments: "",
        status: issueStatusID,
        severity_id: parseInt(severityId),
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      if (
        issueTrackerData &&
        issueTrackerData.message !== "NA" &&
        Array.isArray(issueTrackerData)
      ) {
        this.allBugData = issueTrackerData.map((obj) => {
          return {
            ...obj,
            cdate: Utility.displayDateFormat(obj.cdate),
            udate: Utility.displayDateFormat(obj.udate),
            sch_completion_date:
              obj.sch_completion_date !== undefined
                ? Utility.displayDateFormat(obj.sch_completion_date)
                : "",
            comments: this.formatComments(obj.comments_history),
          };
        });
        this.totalRecords = this.allBugData.length;
      }
    },
    async filterSeverityData(severityId) {
      this.allBugData = [];
      this.totalRecords = 0;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 3,
        issue_id: "0",
        title: "",
        description: "",
        comments: "",
        status: "0",
        severity_id: parseInt(severityId),
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      if (
        issueTrackerData &&
        issueTrackerData.message !== "NA" &&
        Array.isArray(issueTrackerData)
      ) {
        this.allBugData = issueTrackerData.map((obj) => {
          return {
            ...obj,
            cdate: Utility.displayDateFormat(obj.cdate),
            udate: Utility.displayDateFormat(obj.udate),
            sch_completion_date:
              obj.sch_completion_date !== undefined
                ? Utility.displayDateFormat(obj.sch_completion_date)
                : "",
            comments: this.formatComments(obj.comments_history),
          };
        });
        this.totalRecords = this.allBugData.length;
      }
    },
    async filterStatusData(issueStatusID) {
      this.allBugData = [];
      this.totalRecords = 0;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: 3,
        issue_id: "0",
        title: "",
        description: "",
        comments: "",
        status: issueStatusID,
        severity_id: 0,
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      if (
        issueTrackerData &&
        issueTrackerData.message !== "NA" &&
        Array.isArray(issueTrackerData)
      ) {
        this.allBugData = issueTrackerData.map((obj) => {
          return {
            ...obj,
            cdate: Utility.displayDateFormat(obj.cdate),
            udate: Utility.displayDateFormat(obj.udate),
            sch_completion_date:
              obj.sch_completion_date !== undefined
                ? Utility.displayDateFormat(obj.sch_completion_date)
                : "",
            comments: this.formatComments(obj.comments_history),
          };
        });
        this.totalRecords = this.allBugData.length;
      }
    },
    //Updating Data Table array
    filterValueUpdate(data) {
      this.totalRecords = data.length;
      this.allBugData = data;
    },
    //Get Filter Details
    async getFilterData() {
      let issueObj = {
        pass: 12,
      };
      let showMessage = false;
      let data = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      if (data !== null && data !== undefined && data.message !== "NA") {
        this.filterOriginalData = data;
        this.filterData = this.distinctValues(data);
      }
    },
    //Getting distinct values for filters
    distinctValues(data) {
      if (data.length > 0) {
        const sourceObject = data[0];
        const result = {};
        for (const key in sourceObject) {
          if (Object.hasOwnProperty.call(sourceObject, key)) {
            const items = sourceObject[key];
            if (Array.isArray(items)) {
              if (key === "severity") {
                result[key] = items.map((item) => item.type);
              } else if (key === "status") {
                result[key] = items.map((item) => item.issue_status);
              }
            }
          }
        }
        return result;
      }
    },
    //Close the popup
    closeDialog() {
      this.$refs.issueStatusChangeForm.resetValidation();
      this.getIssueStatusList();
      if (this.filterStatus !== "" && this.filterStatus !== undefined) {
        this.filterSelected(this.filterStatus, 2);
      } else if (
        this.filterSeverity !== "" &&
        this.filterSeverity !== undefined
      ) {
        this.filterSelected(this.filterSeverity, 1);
      } else {
        this.getAllIssueDetails(3);
      }
    },
    clearFilter() {
      this.filterStatus = "";
      this.filterSeverity = "";
      this.getAllIssueDetails(3);
      EncryptUtility.localStorageEncrypt("FTServerityName", "" );
      EncryptUtility.localStorageEncrypt("FTStatusName","");
    },
    //Issue Details
    async issueDetails(item) {
      this.$router.push({
        name: "feedbackTrackerDetails",
        params: {
          issueId: btoa(item.issue_id.toString()),
        },
      });
      EncryptUtility.localStorageEncrypt("searchText",this.searchBugs );

    },
    // show CLosed
    showClosed() {
      this.showClosedSwitch
        ? this.getAllIssueDetails(8)
        : this.getAllIssueDetails(3);
    },
    //Ge,t Issue status list
    async getIssueStatusList() {
      this.bugStatusList = [];
      this.totalRecords = 0;
      let pass = 4;
      let issueObj = {
        UserId: parseInt(this.userId),
        pass: parseInt(pass),
      };
      let showMessage = false;
      let issueTrackerData = await issueService.postIssueTracker(
        "post",
        issueObj,
        showMessage
      );
      this.bugStatusList = issueTrackerData;
    },
    // To get the action List
    actionSetter(action) {
      if (
        this.actionList !== undefined &&
        this.actionList !== null &&
        this.actionList !== ""
      ) {
        let filter = this.actionList.filter(
          (entry) => entry.SystemName === action
        );
        return filter !== undefined && filter !== null && filter.length == 1
          ? true
          : false;
      } else return false;
    },
    async getChartData(dateValue) {
      let feedbackObj = {
        type: dateValue,
        start_date: Utility.inputDateFormat(
          this.computedStartDateFormattedMomentjs,
          "00:00:00"
        ),
        end_date: Utility.inputDateFormat(
          this.computedEndDateFormattedMomentjs,
          "23:59:59"
        ),
      };
      let responseData = await issueService.postFeedbackDashboard(
        "post",
        feedbackObj,
        false
      );
      this.feedbackIssueData = responseData[0].issue_status;
      this.feedbackServityData = responseData[0].issue_severity;
    },
    onChangeDateRange() {
      this.getChartData(this.dateValue);
    },
    onClickApply() {
      this.getChartData(6);
    },
    onClickChart(loc,label){
      if(loc=="status"){
      let issue_id=this.feedbackIssueData.find(
        (item) => item.issue_status === label
      )?.issue_status_id;
      this.filterSeverityStatusData(0,issue_id);
    }
      else if(loc=="serverity"){
      let severity_id=this.feedbackServityData.find(
        (item) => item.issue_severity === label
      )?.severity_id;
       this.filterSeverityStatusData(severity_id,0);
    }
      this.$vuetify.goTo(document.body.scrollHeight)
      
    },

  },
  components: {
    breadcrumbComp,
    DisplayTextData,
    FilterComp,
    PieChart,
  },
    watch: {
    panel(val) {
      let panelId=val==0?"open":"close"
       EncryptUtility.localStorageEncrypt(
            "panelId",
            panelId
          );
    },
  },
};
